import React from 'react'
import NaBar from "../components/NavBar";
import HeroImg2 from "../components/HeroImg2";
import Footer from "../components/Footer";
import AboutContent from '../components/AboutContent';


const About = () => {
  return (
    <div>
      <NaBar/>
      <HeroImg2 heading="עלינו" text=""/>
      <AboutContent/>
      <Footer/>
      
    </div>
  );
}

export default About
